import { Controller } from '@hotwired/stimulus';

const FOCUSABLE_SELECTOR = [
  'input:not([type="hidden"]):not([disabled])',
  'button:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'a[href]',
].join(', ');

export default class extends Controller {
  static targets = ['trigger', 'content'];

  show() {
    this.contentTargets.forEach((content) => content.classList.remove('hidden'));
    this.triggerTargets.forEach((trigger) => trigger.classList.add('hidden'));

    this.#focusRevealedContent();
  }

  // The trigger hides itself, so the focus it was holding would fall back to
  // the body: it is handed over to the content that just appeared instead.
  #focusRevealedContent() {
    if (!this.hasContentTarget) return;

    const focusable = this.contentTarget.querySelector(FOCUSABLE_SELECTOR);

    if (focusable) {
      focusable.focus();
      return;
    }

    this.contentTarget.setAttribute('tabindex', '-1');
    this.contentTarget.focus();
  }
}
